<script setup>
</script>

<template>
    <div class="w-[100px] h-[36px] bg-blue-500 rounded-[10px] flex items-center justify-center gap-2 hover:bg-blue-600 select-none cursor-pointer duration-200 transition-all">
        <div class="text-white">
            Оплатить
        </div>
    </div>
</template>

<style scoped>

</style>